import { assertUnreachable } from "@fidget/common/utils/ts-utils";
import React from "react";
import { DescriptionPair, TextDecoration } from "../../../RichMessageTypes";
import style from "./DescriptionPairContent.css";

interface Props {
  descriptions: DescriptionPair[];
}

export const DescriptionPairContent = ({ descriptions }: Props) => {
  const applyDecoration = (decoration: TextDecoration) => {
    switch (decoration) {
      case "BOLD":
        return { fontWeight: "bold" };
      case "ITALIC":
        return { fontStyle: "italic" };
      case "UNDERLINE":
        return { textDecoration: "underline" };
      default:
        assertUnreachable(decoration);
        return undefined;
    }
  };

  return (
    <div className={style.container}>
      {descriptions.map((description) => {
        return (
          <div key={description.key.text}>
            <span style={description.key.decoration && applyDecoration(description.key.decoration)}>
              {description.key.text}{" "}
            </span>
            :
            <span
              style={description.value.decoration && applyDecoration(description.value.decoration)}
            >
              {" "}
              {description.value.text}
            </span>
          </div>
        );
      })}
    </div>
  );
};
